import { render, staticRenderFns } from "./assignCategorySelect.vue?vue&type=template&id=2de62020"
import script from "./assignCategorySelect.vue?vue&type=script&lang=js"
export * from "./assignCategorySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2de62020')) {
      api.createRecord('2de62020', component.options)
    } else {
      api.reload('2de62020', component.options)
    }
    module.hot.accept("./assignCategorySelect.vue?vue&type=template&id=2de62020", function () {
      api.rerender('2de62020', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/brand/settings/assignCategorySelect.vue"
export default component.exports